import {observable,action} from 'mobx'
import {getVal,setVal} from '../../../utils/server'

//缓存报警规则
class HandledAlertStore{
  @observable checkAlert = getVal("checkAlert",{})

  @action setCheckAlert(info){
    this.checkAlert = info
    setVal("checkAlert",this.checkAlert)
  }
}

export default new HandledAlertStore()


// WEBPACK FOOTER //
// ./src/routes/Alert/handled-alerts/store.js